import { useState, useEffect } from 'react';
import {
  Container,
  Content,
  Line,
  Name,
  Date,
  Tag,
  IconDown,
} from './styled';
import { Modal, TransferClient } from '../../../../components'
import { BsHeadset } from 'react-icons/bs';
import { BiTransfer } from 'react-icons/bi';
import moment from 'moment';
import { maskDate, maskZero } from '../../../../utils';



export function Open(props) {
  const { customerService, onClose } = props;
  const [date, setDate] = useState('');
  const [transfer, setTransfer] = useState(false);


  useEffect(() => {
    const date = maskDate(customerService.started_at);
    setDate(date);
  }, [customerService])

  const titleTransfer = () => {
    return (
      <div style={{ maxWidth: "25rem" }}>
        Transferir
        <span style={{ fontWeight: "bolder", padding: '0 0.5rem 0 0.5rem' }}>
          {customerService?.client_name}
        </span>
        para :
      </div>
    );
  }

  return (
    <Container active={false}>
      <Content>
        <Line>
          <Name>
            <span>{customerService.client_name}</span>
          </Name>
          <Date>
            <span>
              {date + ' - ' + moment(customerService.started_at).format('HH:mm')}
            </span>
          </Date>
        </Line>
        <Line>
          <div className='infoUser'>
            <Tag type='inFo'>
              {maskZero(customerService.id)}
            </Tag>
            <Tag type='inFo'>
              <span><BsHeadset /></span>
              <p>{customerService.nomecompleto}</p>
            </Tag>
          </div>
          <IconDown>
            <BiTransfer onClick={() => setTransfer(true)} style={{ fontSize: '1.3rem' }} />
          </IconDown>
        </Line>
        {customerService.type === 'VIDEOCHAMADA' &&
          <Line>
            <div className='call--status'>
              {customerService.link === 'IN CALL'
                ? <Tag type='in call'>
                  Em Chamada
                </Tag>
                : <Tag type='invite'>
                  Convite Recebido
                </Tag>
              }
            </div>
          </Line>
        }
      </Content>
      <Modal
        title={titleTransfer()}
        isOpen={transfer}
        close={() => setTransfer(false)}
      >
        {transfer &&
          <TransferClient
            customer={customerService}
            close={() => {
              setTransfer(false)
              onClose()
            }}
          />
        }
      </Modal>
    </Container>
  );
}